import React from 'react';

interface SkeletonLoaderProps {
  width?: string;
  height?: string;
  className?: string;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ 
  width = 'w-full', 
  height = 'h-4', 
  className = '' 
}) => {
  return (
    <div 
      className={`${width} ${height} bg-gray-700 animate-pulse rounded ${className}`}
    />
  );
};

export default SkeletonLoader;